import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted';
import { IconHighlightedType } from '@kubit/web-ui-components/iconHighlighted/types';
import { NavigationRowVariantType } from '../../../../../../components/navigationRow/types/navigationRow';
import { AvatarProfileSizeType, AvatarProfileVariantType, IconHighlightedVariantType, } from '../../variants';
import { commonStyles } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [NavigationRowVariantType.REGULAR]: {
            ...commonStyles(FOUNDATIONS, FONT),
            icon: {
                width: FOUNDATIONS.size_300,
                height: FOUNDATIONS.size_300,
                color: FOUNDATIONS.color_comp_navigation_navigationrow_righticon_icon,
            },
            iconHighlighted: {
                variant: IconHighlightedVariantType.CIRCLE,
                size: IconHighlightedSizeType.SMALL,
                type: IconHighlightedType.INFORMATIVE,
                color: FOUNDATIONS.color_secondary_icon_100,
                background_color: FOUNDATIONS.color_neutral_bg_300,
            },
            avatarProfile: {
                variant: AvatarProfileVariantType.IMAGE,
                size: AvatarProfileSizeType.SMALL,
            },
        },
    };
};
//# sourceMappingURL=regular.js.map